import { createContext, ReactNode, useCallback, useContext, useState } from 'react'
import * as React from 'react'

interface UsePageInfoContextProps {
  // TODO: to be fixed, should be rich text json
  additionalFooterDisclaimer: any[]
  updateAdditionalFooterDisclaimer: (disclaimer: any[]) => void
}

interface UseSetPageInfoContextProps {
  updateAdditionalFooterDisclaimer: (disclaimer: any[]) => void
}

interface PageInfoContextProps extends UsePageInfoContextProps, UseSetPageInfoContextProps {}

export const PageInfoContextProvider = ({ children }: { children: ReactNode }) => {
  const [additionalFooterDisclaimer, setAdditionalFooterDisclaimer] = useState<any[] | undefined>([])

  const updateAdditionalFooterDisclaimer = useCallback((newDisclaimer: any[] = []): void => {
    setAdditionalFooterDisclaimer(newDisclaimer)
  }, [])

  return (
    <PageInfoContext.Provider
      value={{
        additionalFooterDisclaimer,
        updateAdditionalFooterDisclaimer,
      }}
    >
      {children}
    </PageInfoContext.Provider>
  )
}

export const PageInfoContext = createContext<PageInfoContextProps | undefined>({
  additionalFooterDisclaimer: undefined,
  updateAdditionalFooterDisclaimer: () => void 0,
})

export const usePageInfoContext = (): UsePageInfoContextProps => {
  const context = useContext(PageInfoContext)
  if (context === undefined) {
    throw new Error('PageInfoContext must be used within PageInfoContextProvider')
  }

  const { additionalFooterDisclaimer, updateAdditionalFooterDisclaimer } = context
  return {
    additionalFooterDisclaimer,
    updateAdditionalFooterDisclaimer,
  }
}
